(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/pool-betting/draw-widgets/assets/javascripts/widget-container.js') >= 0) return;  svs.modules.push('/components/pool-betting/draw-widgets/assets/javascripts/widget-container.js');
"use strict";

const {
  WidgetPublicContainer,
  WidgetWagerContainer
} = svs.components.poolBetting.drawWidgets;
const WidgetContainer = _ref => {
  let {
    wagerId,
    drawNumber,
    productId,
    className
  } = _ref;
  if (wagerId) {
    return React.createElement(WidgetWagerContainer, {
      className: className,
      wagerId: wagerId
    });
  }
  if (drawNumber && productId) {
    return React.createElement(WidgetPublicContainer, {
      className: className,
      drawNumber: drawNumber,
      productId: productId
    });
  }
  return null;
};
setGlobal('svs.components.poolBetting.drawWidgets.WidgetContainer', WidgetContainer);

 })(window);